import RequestHandler from "./RequestHandler";
// import ErrorWithStatus from "../utils/ErrorWithStatus";

function ModelsAPI() {
    const baseModelsAPI = "models";

    async function getModels(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "materialName";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${baseModelsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || [];
        } catch (error) {
            console.log(error);
        }
    }

    async function updateModel(body) {
        try {
            const result = await RequestHandler.put(baseModelsAPI, body);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function cloneModel(body) {
        try {
            const result = await RequestHandler.post(
                `${baseModelsAPI}/clone`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateModelUserAccesses(body) {
        try {
            const result = await RequestHandler.put(
                `${baseModelsAPI}/model-access`,
                body
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function deleteModel(id) {
        try {
            const result = await RequestHandler.remove(
                `${baseModelsAPI}/${id}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function createModel(body) {
        try {
            const result = await RequestHandler.post(baseModelsAPI, body);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function doesModelNameExist(modelName) {
        try {
            const result = await RequestHandler.get(
                `${baseModelsAPI}/${modelName}`
            );
            return result;
        } catch (error) {
            console.log(error);
        }
    }

    async function getDownloadableModelData(modelId) {
        try {
            const result = await RequestHandler.get(
                `${baseModelsAPI}/download-model-data/${modelId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function getSampleNames(modelId) {
        try {
            const result = await RequestHandler.get(
                `${baseModelsAPI}/sample-names/${modelId}`
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        getModels,
        updateModel,
        cloneModel,
        deleteModel,
        createModel,
        doesModelNameExist,
        getDownloadableModelData,
        updateModelUserAccesses,
        getSampleNames,
    };
}

export default ModelsAPI();
